var map = {
	"./dashboardRelatorios.js": "qUxp",
	"./index.js": "lusN",
	"./relatoriosOs.js": "rf5R"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KD+n";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/relatorios nonrecursive \.js$
// module id = KD+n
// module chunks = 12